/* eslint-disable import/no-default-export */
import { Errors } from '@/defines/errors'
const actionErrorHandler = (err, moduleName, actionName) => {
  // 运行js报错
  if (err instanceof Error) {
    return Promise.reject({
      type: Errors.COMMON.PROGRAM_ERROR,
      error: err,
      from: `${moduleName}/${actionName}`
    })
  }
  // 后端返回业务异常
  if (Object.prototype.hasOwnProperty.call(err, 'ret') && err.ret === 0) {
    // 未登录
    if (err.error.code === 2003 || err.error.code === 1012002) {
      return Promise.reject({
        type: Errors.AUTH.NOT_LOGIN,
        error: err.error,
        from: `${moduleName}/${actionName}`
      })
    } else {
      return Promise.reject({
        type: Errors.AJAX.RESPONSE_ERROR,
        error: err.error,
        from: `${moduleName}/${actionName}`
      })
    }
  }
  // 网络异常
  if (
    Object.prototype.hasOwnProperty.call(err, 'url') &&
    Object.prototype.hasOwnProperty.call(err, 'status')
  ) {
    return Promise.reject({
      type: Errors.AJAX.NETWORK_ERROR,
      response: err,
      from: `${moduleName}/${actionName}`
    })
  }
  // 已经在action内定义过type的rejection
  if (Object.prototype.hasOwnProperty.call(err, 'type')) {
    return Promise.reject(
      Object.assign(err, { from: `${moduleName}/${actionName}` })
    )
  }
  // 其余未知的
  return Promise.reject({
    type: Errors.COMMON.UNKNOWN_ERROR,
    err,
    from: `${moduleName}/${actionName}`
  })
}

export default function (actions, moduleName) {
  Object.keys(actions).forEach(actionName => {
    const actionFunc = actions[actionName]
    actions[actionName] = function (...args) {
      const result = actionFunc.apply(this, args)
      // 鉴定是否为promise
      if (typeof result === 'object' && result.catch) {
        return result.catch(err =>
          actionErrorHandler(err, moduleName, actionName)
        )
      }
      return result
    }
  })
  return actions
}
